(function () {
  'use strict';

  // ─── LOAD MORE ─────────────────────────────────────────────
  function initLoadMore() {
    var btn = document.querySelector('[data-loadmore]');
    if (!btn) return;

    btn.addEventListener('click', async function () {
      var url = btn.dataset.nextUrl;
      if (!url) return;

      btn.disabled = true;
      btn.textContent = 'Carregando...';

      try {
        var res = await fetch(url);
        if (!res.ok) throw new Error('Network error');
        var html = await res.text();
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        var newCards = doc.querySelectorAll('[data-blog-card]');
        var grid = document.querySelector('[data-blog-grid]');
        if (grid && newCards.length) {
          newCards.forEach(function (card) { grid.appendChild(card); });
        }

        // Update progress
        var newProgress = doc.querySelector('[data-blog-progress]');
        var curProgress = document.querySelector('[data-blog-progress]');
        if (newProgress && curProgress) curProgress.innerHTML = newProgress.innerHTML;

        var newFill = doc.querySelector('[data-blog-fill]');
        var curFill = document.querySelector('[data-blog-fill]');
        if (newFill && curFill) curFill.style.width = newFill.style.width;

        var newBtn = doc.querySelector('[data-loadmore]');
        if (newBtn && newBtn.dataset.nextUrl) {
          btn.dataset.nextUrl = newBtn.dataset.nextUrl;
          btn.disabled = false;
          btn.innerHTML = 'Carregar mais artigos <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>';
        } else {
          btn.remove();
        }
      } catch (err) {
        btn.disabled = false;
        btn.textContent = 'Carregar mais artigos';
        console.error('Load more error:', err);
      }
    });
  }

  // ─── SORT (client-side reorder for small blogs) ────────────
  function initSort() {
    var select = document.querySelector('.aiello-ltool__sort-select, .aiello-bgrid__sort-select');
    if (!select) return;

    select.addEventListener('change', function () {
      var grid = document.querySelector('[data-blog-grid]');
      if (!grid) return;

      var cards = Array.from(grid.querySelectorAll('[data-blog-card]'));
      if (!cards.length) return;

      cards.sort(function (a, b) {
        var dateA = new Date(a.dataset.publishedAt || 0);
        var dateB = new Date(b.dataset.publishedAt || 0);
        return select.value === 'asc' ? dateA - dateB : dateB - dateA;
      });

      cards.forEach(function (card) { grid.appendChild(card); });
    });
  }

  function init() {
    initLoadMore();
    initSort();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
